import { AxiosInstance } from "axios";

export function cancelStudentSubscriptionBuilder(apiClient: AxiosInstance) {
  return async function cancelStudentSubscription(
    subscriptionId: any,
    reason: any
  ): Promise<void> {
    const response = await apiClient.post(
      `/packages/student-packages/${subscriptionId}/cancel/`,
      {
        cancellation_reason: reason,
      }
    );
    return response.data;
  };
}
